import classNames from "classnames";
import { isString } from "lodash-es";
import React, { ReactNode, useMemo } from "react";

import { Flex } from "../Flex";
import { IPositionWrapperProps } from "../PositionWrapper";
import { IStylePadding, IStyleSize, TStyleSize } from "../Style";

interface IStyleProps extends IStylePadding, IStyleSize {}

export interface ITooltipComponentProps extends Pick<IPositionWrapperProps, "placement">, Partial<IStyleProps> {
  content?: ReactNode;
  arrowSize?: TStyleSize;
  radius?: boolean;
}

export const TooltipComponent: React.FC<ITooltipComponentProps> = ({
  padding,
  content,
  size,
  arrowSize,
  radius,
  placement,
}) => {
  const contentClassNames = useMemo(
    () =>
      classNames("tooltip", {
        "tooltip--radius": radius,
        [`tooltip--arrow-size-${arrowSize}`]: !!arrowSize,
        [`tooltip--size-${size}`]: !!size,
        [`tooltip--placement-${placement}`]: !!placement,
      }),
    [arrowSize, radius, size, placement],
  );

  if (!content) {
    return null;
  }

  return (
    <Flex padding={padding} className={contentClassNames}>
      {isString(content) ? <span className="tooltip__text">{content}</span> : content}
    </Flex>
  );
};
